import styled from 'styled-components'
import { FaCheck, FaX } from 'react-icons/fa6'
import { TbPencilCancel } from 'react-icons/tb'

export const Container = styled.div`
  padding: 1.5rem;
  background-color: ${(props) => props.theme.background || '#f5f8fa'};
`

export const MonthSection = styled.div`
  margin-bottom: 2rem;
  background-color: ${(props) => props.theme.cardBackground || '#fff'};
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  transition: transform 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }
`

export const MonthHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem;
  background-color: ${(props) => props.theme.headerBackground || '#f0f4f8'};
  border-bottom: 1px solid ${(props) => props.theme.borderColor || '#eaedf0'};
`

export const MonthTitle = styled.h2`
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: ${(props) => props.theme.titleColor || '#2d3748'};
`

export const ReportButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1rem;
  border: none;
  border-radius: 8px;
  font-weight: 500;
  color: #fff;
  background-color: ${(props) => props.theme.button?.blue || '#3182ce'};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${(props) => props.theme.button?.hoverBlue || '#2b6cb0'};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(1px);
  }
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`

export const TableHead = styled.thead`
  background-color: ${(props) => props.theme.tableHeaderBg || '#f7fafc'};
`

export const TableHeaderCell = styled.th`
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  color: ${(props) => props.theme.textSecondary || '#4a5568'};
  font-size: 0.875rem;
  white-space: nowrap;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 2px;
    background-color: ${(props) => props.theme.button?.blue || '#3182ce'};
    transition: width 0.3s ease;
  }

  &:hover:after {
    width: 100%;
  }
`

export const TableRow = styled.tr`
  border-bottom: 1px solid ${(props) => props.theme.borderColor || '#edf2f7'};
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${(props) => props.theme.rowHoverBg || '#f8fafc'};
  }

  &:last-child {
    border-bottom: none;
  }
`

export const TableCell = styled.td`
  padding: 1rem;
  color: ${(props) => props.theme.text?.main || '#2d3748'};
  font-size: 0.9rem;
`

export const StatusBadge = styled.span<{ $status: string }>`
  display: inline-flex;
  align-items: center;
  padding: 0.35rem 0.75rem;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 500;
  text-transform: capitalize;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);

  ${(props) => {
    switch (props.$status) {
      case 'pending':
        return `
          background-color: #fff8e6;
          color: #b7791f;
          border: 1px solid #fbd38d;
        `
      case 'approved':
        return `
          background-color: #e6f6e6;
          color: #2f855a;
          border: 1px solid #9ae6b4;
        `
      case 'rejected':
        return `
          background-color: #fee2e2;
          color: #e53e3e;
          border: 1px solid #f8b4b4;
        `
      case 'cancelled':
        return `
          background-color: #e6f0f9;
          color: #2b6cb0;
          border: 1px solid #a4cafe;
        `
      default:
        return `
          background-color: #f0f0f0;
          color: #4a5568;
          border: 1px solid #e2e8f0;
        `
    }
  }}
`

export const ActionsContainer = styled.div`
  display: flex;
  gap: 0.6rem;
`

export const ActionButton = styled.button<{ $color?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2rem;
  height: 2rem;
  border: none;
  border-radius: 6px;
  background-color: ${(props) => (props.$color ? `${props.$color}15` : '#f0f4f8')};
  color: ${(props) => props.$color || '#4a5568'};
  cursor: pointer;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);

  &:hover {
    background-color: ${(props) => (props.$color ? `${props.$color}25` : '#e2e8f0')};
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(1px);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  }
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  background-color: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  color: ${(props) => props.theme.textSecondary || '#4a5568'};
  font-size: 1rem;
  text-align: center;

  p {
    margin: 0;
    opacity: 0.8;
  }
`

// Export the icons directly as well
export const ApproveIcon = styled(FaCheck)``
export const DenyIcon = styled(FaX)``
export const CancelIcon = styled(TbPencilCancel)``

// Fix for TypeScript errors
export const Header = styled.div`
  /* This ensures backward compatibility */
  display: flex;

  & > span {
    flex: 1;
  }
`

export const RaportButton = ReportButton
